import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TPATestData } from '../models/tpa-test-data.modal';

@Injectable({
  providedIn: 'root',
})
export class TpaService {
  constructor(private http: HttpClient) {}

  viewTestData(projectId: string, fileName: string): Observable<TPATestData> {
    const params = new HttpParams()
      .set('projectId', projectId)
      .set('fileName', fileName);
    return this.http.post<TPATestData>(`${environment.baseUrl}tpa/viewtestdata`, null, {
      params,
    });
  }
}
